import { MAX_SIDEBAR_NEW_REQUESTS_THRESHOLD } from "@/constants";
import { useEffect } from "react";

export const useRefetch = (count: number, refetch: () => void) => {
  useEffect(() => {
    if (count > 0 && count < MAX_SIDEBAR_NEW_REQUESTS_THRESHOLD) refetch();
  }, [count, refetch]);
};
